import React, { useState, useEffect } from "react";
import DocumentAutosuggest from "../../document/DocumentAutosuggest";
import {
  DialogActions,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

function DocumentLinkDialog(props) {
  const [documentLinkTitle, setDocumentLinkTitle] = useState("");
  const [selectedDocument, setSelectedDocument] = useState({});
  const [newTab, setNewTab] = useState(true);
  const { t } = useTranslation();

  useEffect(
    () => {
      if (props.edit) {
        setDocumentLinkTitle(props.edit.getText());
        let href = props.edit.getAttribute("href");
        setSelectedDocument({ documentId: href.split("/").pop() });
        let target = props.edit.getAttribute("target");
        if (target === "_self") {
          setNewTab(false);
        }
      }
    },
    [props.edit]
  );

  return (
    <Dialog
      style={{ zIndex: 10001 }}
      open={props.open}
      onClose={props.onClose}
      PaperProps={{ style: { overflow: "inherit" } }}
    >
      <DialogTitle>
        {props.edit
          ? t("slate_edit_document_link")
          : t("slate_insert_document_link")}
      </DialogTitle>
      <DialogContent>
        <TextField
          error={!documentLinkTitle}
          helperText={!documentLinkTitle ? t("global_required") : ""}
          style={{ marginBottom: 5 }}
          id="outlined-name"
          aria-label="Link title input"
          label={t("slate_link_title")}
          value={documentLinkTitle}
          fullWidth
          onChange={(e) => {
            setDocumentLinkTitle(e.target.value);
          }}
        />
        <FormControlLabel
          style={{ marginBottom: 5 }}
          label="Open link in new tab"
          control={
            <Checkbox
              checked={newTab}
              onChange={(e) => setNewTab(e.target.checked)}
              color="primary"
            />
          }
        />
        <DocumentAutosuggest
          onItemSelected={(item) => setSelectedDocument(item)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="default">
          {t("global_cancel")}
        </Button>
        <Button
          aria-label="Insert"
          id="document-link-insert"
          disabled={!documentLinkTitle}
          onClick={() => {
            let id = selectedDocument.documentId;
            if (selectedDocument.documentID) {
              id = selectedDocument.documentID;
            }
            props.edit
              ? props.onSubmitEdit(documentLinkTitle, id, newTab)
              : props.onSubmit(documentLinkTitle, id, newTab);
          }}
          color="default"
        >
          {t("global_insert")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DocumentLinkDialog;
